export class EnaioProject {
    //netgen start
    id = 0;
    projectNumber: string;
    title: string;
    //netgen end

    getHtmlTitle(withProjectNumber = false): string {
        let s = this.title;
        if (withProjectNumber) {
            s += " <span style='color: $00ffff; font-size: smaller'>[" + this.projectNumber + "]</span>";
        }
        return s;
    }
}
